module.exports = __webpack_public_path__ + "img/fiorentina.1d1b7edb.png";